var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"page-container",class:{ 'with-tabbar': !(_vm.$route.meta && _vm.$route.meta.hideTabbar) }},[_c('router-view')],1),(!(_vm.$route.meta && _vm.$route.meta.hideTabbar))?_c('TabbarMain'):_vm._e(),_c('LoadingOverlay',{attrs:{"isLoading":_vm.isGlobalLoading,"loadingText":_vm.loadingText}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }